import React from 'react';
import './KnowledgePanel.css';

const PHONE = '050 0000 0001';
const CHAT_LABEL = '・お店とチャットする';

// RBMエージェントIDをクエリに基づいて決定する関数
function getChatUrl(query) {
  const normalizedQuery = query.toLowerCase();

  if (normalizedQuery.includes('イタリアン')) {
    return 'sms:testaggaix010_unn6bqjj_agent@rbm.goog?body=%E3%81%93%E3%81%AE%E3%81%BE%E3%81%BE%E9%80%81%E4%BF%A1%E3%81%97%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84';
  }

  if (normalizedQuery.includes('和食')) {
    return 'sms:testaggaix002_nvsqoatf_agent@rbm.goog';
  }

  return 'sms:testaggaix010_unn6bqjj_agent@rbm.goog?body=%E3%81%93%E3%81%AE%E3%81%BE%E3%81%BE%E9%80%81%E4%BF%A1%E3%81%97%E3%81%A6%E3%81%8F%E3%81%A0%E3%81%95%E3%81%84';
}

// レストラン情報をクエリに基づいて決定する関数
function getRestaurantInfo(query) {
  const normalizedQuery = query.toLowerCase();

  if (normalizedQuery.includes('イタリアン')) {
    return {
      name: 'レストランクロス',
      category: 'イタリアンレストラン',
      logoSrc: '/restaurantcross-logo.jpg',
      websiteUrl: 'https://aicross.co.jp',
      websiteDomain: 'restaurantcross.jp',
    };
  }

  return {
    name: '和食割烹クロス',
    category: '和食レストラン',
    logoSrc: '/kappocross-logo.png',
    websiteUrl: 'https://aicross.co.jp',
    websiteDomain: 'kappocross.jp',
  };
}

export default function KnowledgePanel({ query }) {
  const CHAT_URL = getChatUrl(query);
  const restaurantInfo = getRestaurantInfo(query);
  return (
    <div className="kp-wrapper">
      {/* Header */}
      <div className="kp-header">
        <div className="kp-title-block">
          <h2 className="kp-name">{restaurantInfo.name}</h2>
          <p className="kp-category">{restaurantInfo.category}</p>
        </div>
        <img src={restaurantInfo.logoSrc} alt="logo" className="kp-logo" />
      </div>

      {/* Detail rows */}
      <div className="kp-detail-rows">
        {/* Phone */}
        <a href={`tel:${PHONE.replace(/ /g, '')}`} className="kp-detail-row kp-detail-link">
          <img src="/phoneicon.png" alt="phone" className="kp-row-icon" />
          <div className="kp-row-content">
            <span className="kp-row-main">{PHONE}</span>
          </div>
          <svg className="kp-row-chevron" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
        </a>

        {/* RCS / Chat row */}
        <a href={CHAT_URL} className="kp-detail-row kp-detail-link">
          <img src="/messagesicon.png" alt="messages" className="kp-row-icon kp-msg-icon" />
          <div className="kp-row-content">
            <span className="kp-row-main kp-chat-label">{CHAT_LABEL}</span>
            <span className="kp-row-sub">メッセージアプリで開く</span>
          </div>
          <svg className="kp-row-chevron" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
        </a>

        {/* Website */}
        <a href={restaurantInfo.websiteUrl} className="kp-detail-row kp-detail-link">
          <img src="/webicon.png" alt="web" className="kp-row-icon" />
          <div className="kp-row-content">
            <span className="kp-row-main">{restaurantInfo.websiteDomain}</span>
            <span className="kp-row-sub">電話、メール、チャットなど</span>
          </div>
          <svg className="kp-row-chevron" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
        </a>
      </div>

      <div className="kp-feedback">フィードバック</div>
    </div>
  );
}
